module.exports = __webpack_public_path__ + "img/em2.f4fdb22e.jpg";